"use client";

import { ArrowRight, PhoneCall } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function VamosExpandirSeusNegocios() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="232590" id="start-your-production" className="bg-background text-foreground py-24 md:py-32 relative overflow-hidden dark">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] md:w-[800px] md:h-[800px] bg-primary/20 rounded-lg blur-[120px] pointer-events-none"></div>
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff08_1px,transparent_1px),linear-gradient(to_bottom,#ffffff08_1px,transparent_1px)] bg-[size:32px_32px] pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-4xl mx-auto text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {}
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-md bg-primary/10 text-primary text-xs font-mono mb-8 border border-primary/30 shadow-md">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75"></span>
              <span className="relative inline-flex rounded-lg h-2 w-2 bg-primary"></span>
            </span>
            LIVE PRODUCTION READY
          </div>

          {}
          <h2 className="font-black font-default mb-6 tracking-tighter text-balance uppercase italic !text-5xl">Ready to make your&nbsp; event unforgettable ?</h2>

          <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto text-balance leading-relaxed font-default">From intimate weddings to large scale live events, Pulse AV delivers the AV solutions that make the difference. Get in touch today for a free no obligation quote tailored to your event.</p>

          {}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button asChild size="lg" className="w-full sm:w-auto h-14 px-10 text-lg font-bold uppercase tracking-wider shadow-lg shadow-primary/40 hover:scale-105 transition-transform duration-300">
              <Link to="/GetAQuotePage"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-phone-call mr-2 size-5" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/VamosExpandirSeusNegocios.tsx|sig:8z9uvs" data-ast-start="2549" data-ast-end="2586"><path d="M13 2a9 9 0 0 1 9 9"></path><path d="M13 6a5 5 0 0 1 5 5"></path><path d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.8 1.6l-.468.351a1 1 0 0 0-.292 1.233 14 14 0 0 0 6.392 6.384"></path></svg>GET A QUOTE</Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-14 px-8 text-base border-border bg-card/40 backdrop-blur-xl hover:bg-accent/20 group">
              
            </Button>
          </div>

          
        </div>
      </div>
    </section>;
}